import { render, staticRenderFns } from "./CompanyActionRecommendPage.vue?vue&type=template&id=9d67b738&"
import script from "./CompanyActionRecommendPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyActionRecommendPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports